// guard.ts
import { typeName } from "./types.mjs";
var UUID_REGEXP = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function isRef(what) {
  return what !== null && what !== void 0;
}
function isNoRef(what) {
  return what === null || what === void 0;
}
function isUndefined(what) {
  return what === void 0;
}
function isNull(what) {
  return what === null;
}
function isBoolean(what) {
  return typeof what === "boolean";
}
function isNumber(what) {
  return typeof what === "number";
}
function isBigInt(what) {
  return typeof what === "bigint";
}
function isString(what) {
  return typeof what === "string";
}
function isSymbol(what) {
  return typeof what === "symbol";
}
function isFunction(what) {
  return typeof what === "function";
}
function isObject(what) {
  return !!(what && typeof what === "object" && !Array.isArray(what));
}
function isArray(what) {
  return Array.isArray(what);
}
function isObjectOrArray(what) {
  return !!(what && typeof what === "object");
}
function isType(what, type) {
  if (typeof type === "function") return what instanceof type;
  switch (type) {
    case "undefined":
      return isUndefined(what);
    case "null":
      return isNull(what);
    case "boolean":
      return isBoolean(what);
    case "number":
      return isNumber(what);
    case "bigint":
      return isBigInt(what);
    case "string":
      return isString(what);
    case "symbol":
      return isSymbol(what);
    case "function":
      return isFunction(what);
    case "object":
      return isObject(what);
    case "array":
      return isArray(what);
  }
  const argument = typeof type === "string" ? `"${type}"` : typeName(type);
  throw new TypeError(`Invalid type specified for check: ${argument}`);
}
function isNonEmptyArray(what) {
  return Array.isArray(what) && what.length > 0;
}
function isNonEmptyString(what) {
  return typeof what === "string" && what.length > 0;
}
function isUUIDString(what) {
  return typeof what === "string" && UUID_REGEXP.test(what);
}
function isArrayOf(what, type) {
  if (!isArray(what)) return false;
  for (const item of what) {
    if (isType(item, type)) continue;
    return false;
  }
  return true;
}
function isNonEmptyArrayOf(what, type) {
  return isNonEmptyArray(what) && isArrayOf(what, type);
}
function isDeepEqual(what, other) {
  if (typeof what !== typeof other) return false;
  if (what == null || other == null) return what === other;
  if (what === other) return true;
  if (Array.isArray(what)) {
    if (!Array.isArray(other)) return false;
    if (what.length !== other.length) return false;
    for (let i = 0; i < what.length; i++) {
      if (!isDeepEqual(what[i], other[i])) return false;
    }
    return true;
  } else if (Array.isArray(other)) {
    return false;
  }
  if (what instanceof Date) {
    if (!(other instanceof Date)) return false;
    return what.getTime() === other.getTime();
  } else if (other instanceof Date) {
    return false;
  }
  if (what instanceof RegExp) {
    if (!(other instanceof RegExp)) return false;
    return what.source === other.source && what.flags === other.flags;
  } else if (other instanceof RegExp) {
    return false;
  }
  if (what instanceof Object) {
    const whatKeys = Object.keys(what).sort();
    const otherKeys = Object.keys(other).sort();
    if (!isDeepEqual(whatKeys, otherKeys)) return false;
    for (const key of whatKeys) {
      if (!isDeepEqual(what[key], other[key])) return false;
    }
    return true;
  }
  return false;
}
export {
  isArray,
  isArrayOf,
  isBigInt,
  isBoolean,
  isDeepEqual,
  isFunction,
  isNoRef,
  isNonEmptyArray,
  isNonEmptyArrayOf,
  isNonEmptyString,
  isNull,
  isNumber,
  isObject,
  isObjectOrArray,
  isRef,
  isString,
  isSymbol,
  isType,
  isUUIDString,
  isUndefined
};
//# sourceMappingURL=guard.mjs.map
